import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const LinearTransformationModule = () => (
  <QPhototModuleSubtopic
    title="Linear Transformation"
    videos={[
      "https://www.youtube.com/embed/vSaADFGFUPw",
      "https://www.youtube.com/embed/6PXS6_dMkFM",
      "https://www.youtube.com/embed/ImoKUiapTsQ",
      "https://www.youtube.com/embed/9VGCLV9nrfQ",
      "https://www.youtube.com/embed/fuCgU5kXpeo"
    ]}
    takeaways={[
      {image:"/cvla_73.png"},
    ]}
    questions={[
      {image:"/cvla_74.png"},
      {image:"/cvla_75.png"},
      {image:"/cvla_76.png"},
      {image:"/cvla_78.png"}
    ]}
    exampleVideos={[]}
  />
);

export default LinearTransformationModule;
